import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import axios from 'axios'
import VueLazyload from 'vue-lazyload'
import VueStripeCheckout from 'vue-stripe-checkout'
import VueAnalytics from 'vue-analytics'
import VueAdsense from 'vue-adsense'
import SocialSharing from 'vue-social-sharing'
import VueI18n from 'vue-i18n'
import VModal from 'vue-js-modal'
import './registerServiceWorker'

Vue.use(Vuex)
Vue.use(Buefy)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/static/images/error-404.svg',
  loading: '/static/images/loading.svg'
})
Vue.use(VueStripeCheckout, 'pk_live_vu92zMShNyZfG8wkw8LEc805')
Vue.use(SocialSharing)
Vue.use(VueI18n)
const data = require('./message.json')
const i18n = new VueI18n({
  locale: 'ja',
  messages: data
})
Vue.component('adsense', VueAdsense)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(VueAnalytics, {
  id: 'UA-106772500-1',
  router
})
Vue.use(VModal)

const store = new Vuex.Store({
  state: {
    ctoggleData: false,
    uploadedFilesName: [],
    isLoggedIn: false,
    isPremium: false,
    count: '0',
    email: '',
    infoMsg: '',
    infoDate: '',
    infoLevel: 'has-text-info'
  },
  mutations: {
    setLogin (state, {email, isLoggedIn, isPremium}) {
      state.email = email
      state.isLoggedIn = isLoggedIn
      state.isPremium = isPremium
    },
    updateMsg (state, {msg, date, level}) {
      state.infoMsg = msg
      state.infoDate = date
      state.infoLevel = level
    },
    updateCount (state, count) {
      state.count = count
    },
    uploadedComplete (state, obj) {
      state.uploadedFilesName = obj
    },
    ctoggle (state, bool) {
      state.ctoggleData = bool
    }
  }
})

Vue.mixin({
  data: function () {
    return {
      baseURL: process.env.BASE_URL
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  data: {},
  router,
  components: {App},
  template: '<App/>',
  store,
  methods: {
    handleClick_changeLanguage (lang) {
      this.$i18n.locale = lang
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js